import {ChangeEvent, useEffect, useState} from 'react'
import ReactSelect, {SingleValue} from 'react-select'
import {AppButton} from 'src/components'
import {useAppDispatch, useAppSelector} from 'src/redux/hooks'
import {authSelector} from 'src/redux/slices/authSlices'
import {
  TNotification,
  notificationSelector,
  resetSearchParams,
  setNotificationType,
  setNotifications,
  setPagination,
  setSearchParams,
} from 'src/redux/slices/notificationSlices'
import {fetchNotifications} from 'src/services/fetcher'
import styled from 'styled-components'
import swal from 'sweetalert'

type TOption = SingleValue<{value: string; label: string}>

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`

const StyledSearchInput = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center;
  border-radius: 0.5rem;
  background-color: #fff;
`

const StyledInput = styled.input`
  flex: 1;
  border-radius: 4px;
  border: 1px solid #cccccc;
  padding: 9px 1rem;
  background-color: transparent;
  width: 100%;
  &:focus,
  &:active {
    border-color: #274070;
  }
`

const StyledButton = styled.button`
  border: 1px solid #274070;
  border-radius: 4px;
  padding: 9px 1rem;
  background-color: #274070;
  min-width: 80px;
  color: white;
  text-transform: uppercase;
  font-weight: 600;
  transition: color 200ms ease-in-out;

  &:hover {
    background-color: #2f508d;
  }
`

const searchOptions = [
  {value: 'type', label: 'TYPE'},
  {value: 'title', label: 'TITLE'},
  {value: 'body', label: 'BODY'},
  {value: 'is_read', label: 'IS READ'},
  {value: 'read_only', label: 'READ ONLY'},
]

const notifTypeOpts: {value: TNotification['type'] | ''; label: string}[] = [
  {value: '', label: 'All Type'},
  {value: 'findoc', label: 'Findoc'},
  {value: 'negotiation', label: 'Negotiation'},
  {value: 'order_sub_header', label: 'Order Sub Header'},
  {value: 'order_submission', label: 'Order Submission'},
  {value: 'sales-order', label: 'Sales Order'},
  {value: 'order', label: 'Order'},
  {value: 'sip', label: 'SIP'},
  {value: 'contract', label: 'Contract'},
]

const notifIsReadOpts = [
  {value: '', label: 'Is Read?'},
  {value: 'true', label: 'SUDAH DIBACA'},
  {value: 'false', label: 'BELUM DIBACA'},
]

const notifReadOnlyOpts = [
  {value: '', label: 'Read Only'},
  {value: 'true', label: 'SUDAH DIBACA SAJA'},
  {value: 'false', label: 'BELUM TERBACA SAJA'},
]

export const SearchInput = () => {
  const auth = useAppSelector(authSelector)
  const dispatch = useAppDispatch()
  const {searchParams, notificationType: type} = useAppSelector(notificationSelector)

  const [isLoading, setIsLoading] = useState(false)

  const handleSearchNotification = async () => {
    try {
      setIsLoading(true)

      const credentials = auth?.credential
      if (!credentials) return

      const res = await fetchNotifications({
        credentials,
        ...searchParams,
      })

      const {data, ...rest} = res.data.data
      dispatch(setNotifications(data as TNotification[]))
      dispatch(setPagination(rest))
    } catch (error: any) {
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    return () => {
      dispatch(resetSearchParams())
    }
  }, [])

  return (
    <Wrapper>
      <StyledSearchInput>
        <div style={{width: 180, position: 'relative', zIndex: 999}}>
          <ReactSelect
            name='notification-type'
            options={notifTypeOpts}
            value={type}
            onChange={(value: any) => {
              dispatch(setNotificationType(value))
              dispatch(setSearchParams({...searchParams, type: value?.value}))
            }}
          />
        </div>

        {/* <ReactSelect
          name='notification-is-read'
          options={notifIsReadOpts}
          value={isRead}
          onChange={(value: any) => setIsRead(value)}
        /> */}

        {/* <ReactSelect
          name='notification-read-only'
          options={notifReadOnlyOpts}
          value={readOnly}
          onChange={(value: any) => setReadOnly(value)}
        /> */}

        <StyledInput
          placeholder='Cari berdasarkan judul'
          value={searchParams?.title ?? ''}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            dispatch(setSearchParams({...searchParams, title: e.target.value}))
          }}
        />

        <StyledInput
          placeholder='Cari berdasarkan body'
          value={searchParams?.body ?? ''}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            dispatch(setSearchParams({...searchParams, body: e.target.value}))
          }}
        />

        <AppButton
          style={{borderRadius: 4}}
          disabled={isLoading}
          isLoading={isLoading}
          text='Search'
          onClick={handleSearchNotification}
        />

        {/* <AppButton style={{borderRadius: 4}} text='Reset' onClick={handleResetSearchParams} /> */}
      </StyledSearchInput>
    </Wrapper>
  )
}
